import { es } from "./es";

/** Textos de la interfaz. Hoy solo español; otro idioma sería otro archivo con el mismo tipo `Textos`. */
export const t = es;
export type { Textos } from "./es";
